import api from './client'
import { postParams } from '../lib/useParams'

export const getUsers = async (prm) => {
  // return api.get('user/list', { params: { P_REQUEST: getParams({}) } })
  return api.post('user/list', postParams({}), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then((result) => {
    return result
  })
}

export const getUser = async (prm) => {
  // return api.get('user/get', { params: { P_REQUEST: getParams({ id: prm }) } }).then((result) => {
  //   return result.data
  // })
  return api.post('user/get', postParams({ id: prm }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then((result) => {
    return result.data
  })
}

export const addUser = async (prm) => {
  return api.post('user/add', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then((result) => {
    return result.data
  })
}

export const updateUser = async (prm) => {
  return api.post('user/update', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then((result) => {
    return result.data
  })
}

export const deleteUser = async (prm) => {
  return api
    .post('user/delete', postParams({ id: prm }), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}

export const updateLangPrefer = async (prm) => {
  return api
    .post('user/updateLang', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}

export const resetPassword = async (prm) => {
  return api
    .post('user/resetPassword', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}

export const getRoleUsers = async (prm) => {
  // return api.get('user/getRoleUsers', { params: { P_REQUEST: getParams(prm) } }).then((result) => {
  //   return result.data
  // })
  return api.post('user/getRoleUsers', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then((result) => {
    return result.data
  })
}

export const getUserApprovedInformings = async (prm) => {
  // return api.get('user/getUserApprovedInformings', { params: { P_REQUEST: getParams(prm) } }).then((result) => {
  //   return result.data
  // })
  return api.post('user/getUserApprovedInformings', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then((result) => {
    return result.data
  })
}
export const selectedUserResetPassword = async (prm) => {
  return api
    .post('user/selectedUserResetPassword', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}
export const addCustomerUser = async (prm) => {
  return api
    .post('user/addCustomerUser', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}
export const deleteCustomerUser = async (prm) => {
  return api
    .post('user/deleteCustomerUser', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}
